import { _enum, boolean, schema, string } from "@anna-money/anna-web-lib/serializer";

export enum PaymentStatus {
  New = "NEW",
  Paid = "PAID",
  Failed = "FAILED",
  RefundRequested = "REFUND_REQUESTED",
  Refunded = "REFUNDED",
}

export class PaymentStatusResponse extends schema(
  {
    status: _enum(PaymentStatus, "PaymentStatus").optional(),
    paymentRequired: boolean().optional(true),
    // A decimal amount, e.g. "19.00" — kept as a string so it round-trips exactly.
    amount: string().optional(),
    canRequestRefund: boolean().optional(false),
  },
  "PaymentStatusResponse",
) {}

export class CheckoutResponseData extends schema(
  {
    isPaid: boolean(),
    paymentRequired: boolean().optional(true),
  },
  "CheckoutResponseData",
) {}

export class RefundData extends schema(
  {
    status: _enum(PaymentStatus, "PaymentStatus"),
  },
  "RefundData",
) {}
